import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import 'react-step-progress-bar/styles.css';
import {
  ProgressBar,
  Step
} from 'react-step-progress-bar';
import {
  saveScore
} from '../../actions/client';
import {
  LA_TEST,
} from '../../constants.js';
import TestResult from './TestResult';
import s from './LossAversion.css';
import cs from './common.css';

class LossAversion extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      questions: [1,2,3,4,5,6,7,8,9,10],
      qNum: 0,
      answers: Array.from({length: 10}),
    };
  }

  componentWillMount() {
    this.generateQuestions();
    this.getNextQuestion();
  }

  getNextQuestion() {
    const {
      answers
    } = this.state;
    const questions = [].concat(this.state.questions);
    let qNum = 11;
    // if more questions get and remove one randomly
    if(questions.length > 0) {
      const index = Math.floor(Math.random() * questions.length);
      qNum = questions[index];
      questions.splice(index,1);
    }
    // update the state with current num and remaining questions
    if(qNum === 11) {
      this.props.saveScore(LA_TEST, answers);
    }
    this.setState(Object.assign({}, this.state, {
      qNum: qNum,
      questions: questions,
    }));
  }

  answerQuestion(gamble) {
    const {
      qNum,
    } = this.state;
    const answers = [].concat(this.state.answers);
    // set answer, get next question
    answers[qNum - 1] = gamble;
    this.setState(Object.assign({}, this.state, {
      answers: answers,
    }), () => {
      this.getNextQuestion();
    });
  }

  render() {
    const {
      qNum,
      questions,
      panes,
    } = this.state;
    if(qNum === 11) {
      return (
        <TestResult />
      );
    } else {
      let scrollBase = 1110;
      if (window.matchMedia('(max-device-width: 1200px)').matches) {
        scrollBase = 940;
      }
      if (window.matchMedia('(max-device-width: 992px) and (orientation: landscape)').matches) {
        scrollBase = 710;
      }
      if (window.matchMedia('(max-device-width: 992px) and (orientation: portrait)').matches) {
        scrollBase = 384;
      }
      if (window.matchMedia('((max-device-width : 414px)').matches) {
        scrollBase = 384;
      }
      if (window.matchMedia('(max-device-width : 375px)').matches) {
        scrollBase = 345;
      }
      if (window.matchMedia('(min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 2)').matches) {
        scrollBase = 738;
      }
      if (window.matchMedia('(min-device-width : 1024px) and (max-device-width : 1366px) and (-webkit-min-device-pixel-ratio: 2)').matches) {
        scrollBase = 994;
      }
      const ctrans = `translate(${-(((this.state.qNum - 1) * 30) + ((this.state.qNum - 1) * scrollBase))}px)`;
      return (
        <div>
          <div className="row">
            <div className="col-md-12">
              <div className={cs.headerRow}>
              <ProgressBar
                unfilledBackground="#BDC2C6"
                filledBackground="#35ccd2"
                height='1px'
                percent={100 / 9 * (9 - questions.length)}
              >
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
                <Step transition="scale">{({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}</Step>
              </ProgressBar>
              </div>
              <div className={cs.headerTitle}>Loss Aversion</div>
            </div>
          </div>
          <div className="row">
            <div className={'col-md-12'} style={{overflow: 'hidden',paddingTop:'30px',paddingBottom:'30px'}}>
              <div className={cs.insidepane} style={{transform: ctrans}}>
                { panes }
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  generateQuestions() {
    const questionVals = [200, 300, 350, 400, 500, 600, 700, 900, 1100, 2100];
    const gambles = [];
    const panes = questionVals.map((val) => {
      const order = Math.floor((Math.random() * 2));
      gambles.push(order === 0 ? [1,0] : [0,1]);
      return (
        <div key={val} className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>Please choose which gamble you would prefer. Each gamble has three equally likely outcomes.</div>
          <div className="row">
          { order === 0 &&
          <div className={'col-md-6 ' + s.gambleBox} onClick={() => this.answerQuestion(1)}>
            <div className={s.gamble}>Gamble 1</div>
            <ReactEcharts option={ this.getChart(100, -100) } style={{ height: 120 }} />
          </div>
          }
          <div className={'col-md-6 ' + s.gambleBox} onClick={() => this.answerQuestion(0)}>
            <div className={s.gamble}>Gamble {order === 0 ? 2:1}</div>
            <ReactEcharts option={ this.getChart(val, -300) } style={{ height: 120 }} />
          </div>
          { order === 1 &&
          <div className={'col-md-6 ' + s.gambleBox} onClick={() => this.answerQuestion(1)}>
            <div className={s.gamble}>Gamble 2</div>
            <ReactEcharts option={ this.getChart(100, -100) } style={{ height: 120 }} />
          </div>
          }
          </div>
        </div>
      );
    });
    this.setState(Object.assign({}, this.state, {
      panes: panes,
      gambles: gambles,
    }));
  }

  getChart(val1, val3) {
    const labelRight = {
      show: true,
      fontSize:14,
      fontWeight:'bold',
      color:'#5b6770',
      position: 'right',
    };
    const labelLeft = {
      show: true,
      fontSize:14,
      fontWeight:'bold',
      color:'#5b6770',
      position: 'left',
    };
    return {
      color: ['#84BD00','#D22630',],
      grid: {
          top: '0',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
      },
      xAxis : [
        {
          type : 'value',
          min: -1000,
          max: 2500,
          splitLine: {show: false},
          axisLabel: {
            show: false,
            fontSize: 14,
            formatter: function (val) {
              if(val < 0) {
                return '-$' + (val * -1).toLocaleString();
              } else if(val > 0) {
                return '$' + val.toLocaleString();
              } else {
                return val;
              }
            },
          },
          axisTick: {show: false},
          axisLine: {
            show: false,
            lineStyle: {
                color: '#5b6770',
            },
          },
        },
      ],
      yAxis : [
        {
          type : 'category',
          data : ['33% chance', '33% chance', '33% chance'],
          axisLabel: {
            show: true,
            fontSize: 14,
          },
          axisTick: {show: false},
          splitLine: {show: false},
          axisLine: {
            lineStyle: {
                color: '#5b6770',
            },
          },
        },
      ],
      series : [
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          itemStyle: {
              normal: {color: 'rgba(0,0,0,0.025)'},
          },
          data: [2500, 2500, 2500],
          animation: false,
        },
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          itemStyle: {
              normal: {color: 'rgba(0,0,0,0.025)'},
          },
          data: [-1000, -1000, -1000],
          animation: false,
          markLine : {
            symbol:'none',
            lineStyle: {
              color:'#FFFFFF',
              type: 'solid',
              width: 3,
            },
            data : [
                {xAxis: 0, name : ''},
            ],
          },
        },
        {
          type:'bar',
          barWidth: '90%',
          silent: true,
          data:[0, {value: 0, label: labelLeft}, {value: val1, label: labelLeft}],
          animation: false,
          label: {
            normal: {
              show: false,
              formatter: function (params) {
                const val = params.data.value;
                if(val < 0) {
                  return '$' + (val * -1).toLocaleString();
                } else if(val > 0) {
                  return '$' + val.toLocaleString();
                } else {
                  return '$0';
                }
              },
            },
          },
        },
        {
          type:'bar',
          barWidth: '90%',
          silent: true,
          data:[{value: val3, label: labelRight}, {value: 0, label: labelLeft}, 0],
          animation: false,
          label: {
            normal: {
              show: false,
              formatter: function (params) {
                const val = params.data.value;
                if(val < 0) {
                  return '- $' + (val * -1).toLocaleString();
                } else if(val > 0) {
                  return '- $' + val.toLocaleString();
                } else {
                  return '$0';
                }
              },
            },
          },
        },
      ],
    };
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveScore,
})(LossAversion);



// WEBPACK FOOTER //
// ./src/components/ClientMode/LossAversion.js